<template>
    <div class="vp-audio" noautohide>
        <img v-if="artwork" :src="artwork" alt="" class="vp-audio-blur" />
        <div class="vp-audio-center">
            <img v-if="artwork" :src="artwork" alt="" class="vp-audio-artwork" />
            <span class="vp-label">{{ t("Listening to audio") }}</span>
            <p v-if="caption" class="vp-audio-caption">{{ caption }}</p>
        </div>
    </div>
</template>

<script setup>
import { useCoreI18n } from "../useCoreI18n.js"

defineProps({
    artwork: { type: String, default: null },
    caption: { type: String, default: "" },
})

const t = useCoreI18n()
</script>

<style>
.vp-audio {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    background: var(--vp-ink);
}

.vp-audio-blur {
    position: absolute;
    inset: -40px;
    width: calc(100% + 80px);
    height: calc(100% + 80px);
    object-fit: cover;
    filter: blur(40px) saturate(1.2);
    opacity: 0.55;
}

.vp-audio-center {
    position: absolute;
    inset: 0;
    padding: 96px 24px 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
}

.vp-audio-artwork {
    width: min(220px, 40vh);
    aspect-ratio: 1;
    border-radius: 14px;
    object-fit: cover;
    box-shadow: 0 12px 32px rgba(21, 18, 13, 0.4);
}

.vp-audio-caption {
    max-width: 640px;
    margin: 0;
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
    color: var(--vp-paper);
    background: rgba(21, 18, 13, 0.72);
}
</style>
